import React from "react";
import {Button, Card, DatePicker, Input, Select, Table,Tabs} from "antd";
import {ShowWasteProfile} from "./popups/ShowWasteProfile";
import {DispatchHistory} from "./popups/DispatchHistory";
import {AccountHotsheet} from "./popups/AccountHotsheet";
import {AddUpdateWorkOrder} from "../../tracks/workorder/popups/AddUpdateWorkOrder";
import {Attachments} from "./popups/Attachments";
import {GeneratorList} from "../../../models/generator";
import {pagination} from "../../../controller/Utils";


const {RangePicker} = DatePicker;
const Search = Input.Search;
const Option = Select.Option;
const {TabPane} = Tabs;

export class InDevelopment extends React.Component {
  state = {
    showWasteProfile: false,
    visibleDispatch: false,
    visibleHotsheet: false,
    showAddWorkOrder: false,
    visibleAttachment: false,
    data: [],
    loading: false,
    pagination: pagination,
  }
  fetchGenerator = (params = {}) => {
    this.setState({loading: true, params});
    GeneratorList(params)
      .then(response => {
        this.setState({
          loading: false,
          data: response.data.results,
        });
      });
  }
  onChangeGenerator = (generator) => {
    this.setState({generator})
  }

  showWasteProfile = (visible) => {
    this.setState({showWasteProfile: visible})
  }
  showDispatchHistory = (visible) => {
    this.setState({visibleDispatch: visible})
  }
  showHotsheet = (visible) => {
    this.setState({visibleHotsheet: visible})
  }
  columns = [
    {
      title: 'Action',
      render: item => <div className="action-column">
        <a title="View"><i className="fa fa-eye"/></a>
        <a title="Edit"><i className="fa fa-pencil"/></a>
        <a title="Move to Trash"><i className="fa fa-trash"/></a>
        <a title="Print"><i className="icon-printer"/></a>
      </div>
    }, {
      title: 'Created Date',
      dataIndex: 'date',
      key: 'date',
    }, {
      title: 'Work Order Number',
      dataIndex: 'wo_number',
      key: 'wo_number',
    }, {
      title: 'Generator',
      dataIndex: 'generator',
      key: 'generator',
    }, {
      title: 'User',
      dataIndex: 'user',
      key: 'user',
    }, {
      title: 'Bill To',
      dataIndex: 'billto',
      key: 'billto',
    }, {
      title: 'Truck Type',
      dataIndex: 'truck_type',
      key: 'truck_type',
    }, {
      title: 'Transporter',
      dataIndex: 'transporter',
      key: 'transporter',
    }, {
      title: 'Service Date',
      dataIndex: 'service_date',
      key: 'service_date',
    }, {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
    }];
  demo = [{
    key: '1',
    date: '01-09-2019',
    wo_number: 32,
    generator: 'New York No. 1 Lake Park',
    user: 'Admin',
    billto: <div>Educational Bus - Lamer St<br/>ID: <span>12345</span></div>,
    truck_type: 'VAC',
    transporter: <div>Able Enviro <br/> WWF </div>,
    service_date: '01-09-2019',
    status: <div><i className="fa fa-dot-circle-o"/> Not Sent</div>
  }, {
    key: '2',
    date: '01-09-2019',
    wo_number: 32,
    generator: 'New York No. 1 Lake Park',
    user: 'Admin',
    billto: <div>Educational Bus - Lamer St<br/>ID: <span>12345</span></div>,
    truck_type: 'VAC',
    transporter: <div>Able Enviro <br/> WWF </div>,
    service_date: '01-09-2019',
    status: <div><i className="fa fa-dot-circle-o"/> Not Sent</div>
  }, {
    key: '3',
    date: '01-09-2019',
    wo_number: 32,
    generator: 'New York No. 1 Lake Park',
    user: 'Admin',
    billto: <div>Educational Bus - Lamer St<br/>ID: <span>12345</span></div>,
    truck_type: 'VAC',
    transporter: <div>Able Enviro <br/> WWF </div>,
    service_date: '01-09-2019',
    status: <div><i className="fa fa-dot-circle-o"/> Not Sent</div>
  }, {
    key: '4',
    date: '01-09-2019',
    wo_number: 32,
    generator: 'New York No. 1 Lake Park',
    user: 'Admin',
    billto: <div>Educational Bus - Lamer St<br/>ID: <span>12345</span></div>,
    truck_type: 'VAC',
    transporter: <div>Able Enviro <br/> WWF </div>,
    service_date: '01-09-2019',
    status: <div><i className="fa fa-dot-circle-o"/> Not Sent</div>
  }, {
    key: '5',
    date: '01-09-2019',
    wo_number: 32,
    generator: 'New York No. 1 Lake Park',
    user: 'Admin',
    billto: <div>Educational Bus - Lamer St<br/>ID: <span>12345</span></div>,
    truck_type: 'VAC',
    transporter: <div>Able Enviro <br/> WWF </div>,
    service_date: '01-09-2019',
    status: <div><i className="fa fa-dot-circle-o"/> Not Sent</div>
  },];

  showAddWorkOrderModel(visible) {
    this.setState({showAddWorkOrder: visible});
  }

  showAttachment(visible) {
    this.setState({visibleAttachment: visible});
  }

  render() {
    const {pagination, generator, data, loading, selectedRowKeys, row_id, printBtnLoading, fields} = this.state;
    const rowSelection = {
      selectedRowKeys,
      onChange: this.onCheckboxSelectChange,
    };
    return (
      <div className="generator-pg" id="main-content">
        <div className="container-fluid">
          <div className="block-header">
            {/*<div className="row clearfix">*/}
            {/*  <div className="col-sm-4 col-12">*/}
            {/*    <h3 className="main-heading">AB Accounts</h3>*/}
            {/*  </div>*/}
            {/*</div>*/}
            <div className="row clearfix fixed-tabs m-t-15">
              <Tabs style={{width:"100%"}} type="card" >
                <TabPane tab="General Information" key="1">
                  <div className="row clearfix m-0">
                    <div className="col-12">
                      <h3 className="main-heading">Generator Information</h3>
                    </div>
                    <div className="col-12 m-b-20 full-select-search">
                      <Select mode="default" labelInValue value={generator} onFocus={this.fetchGenerator} onChange={this.onChangeGenerator} onSearch={(value) => this.fetchGenerator({search: value})}
                              showSearch style={{width: "100%"}} loading={loading} placeholder="Generator">
                        {data.map(d => (<Option key={d.account_number}>{d.company_name}</Option>))}
                      </Select>
                    </div>
                    <div className="col-12">
                      <div className="row clearfix main-card mx-0 m-b-5">
                        <div className="col-sm-3 col-12">
                          <Card
                            title="Name"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <h4>Con Edison</h4>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="Email"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <h4>abc@gmail.com</h4>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="Address"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <h4>587 Middle country rd st james 11780</h4>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="City"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <h4>New York</h4>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="State"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <h4>NYC</h4>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="ZIP Code"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <h4>52145</h4>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="Phone"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <h4>11554488</h4>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="Contact"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <h4>Demo</h4>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="Notes"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <div className="col-12 padding-0 multiple-enrty">
                              <h4>Lorem Ipsum Dolar AMaet</h4>
                            </div>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="Revenue"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <div className="col-12 padding-0 multiple-enrty">
                              <p><a>$10,345.56</a></p>
                            </div>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="Associated Generator"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <div className="col-12 padding-0 multiple-enrty">
                              <h4>Con Anderson</h4>
                            </div>
                          </Card>
                        </div>
                        <div className="col-sm-3 col-12">
                          <Card
                            title="Last Service Date"
                            extra={<a href="#"><i className="fa fa-info"> </i> </a>}
                            style={{width: "100%"}}
                            bordered={false}
                          >
                            <div className="col-12 padding-0 multiple-enrty">
                              <h4>2019-02-07</h4>
                            </div>
                          </Card>
                        </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
                <TabPane tab="Work Orders" key="2">
                   <div className="row clearfix edit-header m-0">
                     <div className="col-12">
                      <h3 className="main-heading">Work Orders</h3>
                    </div>
                      <div className="col-sm-3 col-10">
                        <Search placeholder="Input search text" style={{width: "100%"}}/>
                      </div>
                      <div className="col-sm-3 col-12 padding-0">
                        <Button className="advance-search-btn">Advance</Button>
                        <Button className="advance-search-btn"><i className="fa fa-repeat"/> </Button>
                      </div>
                      <div className="col-sm-4 col-12">
                        <div id="date_range_wrapper">
                          <RangePicker onChange={this.onDateRangeChange}/>
                        </div>
                      </div>
                      <div className="col-sm-2 col-2 padding-0">
                        <Button className="submit-btn h-auto xs-hide" onClick={() => this.showAddWorkOrderModel(true)}
                                type="button">Create Work Order
                        </Button>
                        <button className="btn theme-btn xs-show" type="button"><i className="fa fa-plus"/></button>
                      </div>
                      <div className="col-12 edit-div text-right m-t-10">
                        <span>5 Records</span>
                        <button className="btn btn-edit" title="Trash" onClick={this.onMultipleRowDeleteClick}>
                          <i className="fa fa-trash-o"/>
                        </button>
                        <button type="primary" onClick={this.onMultipleRowShowClick} className="btn btn-edit">
                          <i className="fa fa-print"/>
                        </button>
                        <button type="primary" onClick={this.onMultipleRowShowClick} className="btn btn-edit">
                          <i className="fa fa-eye"/>
                        </button>
                      </div>
                    </div>
                  <div className="row clearfix m-0">
                    <div className="col-12">
                      <div className="listing-table">
                        <Table rowKey={row => row.key} className="responsive-table table table-hover" columns={this.columns} dataSource={this.demo}/>
                      </div>
                    </div>
                  </div>
                </TabPane>
                <TabPane tab="Tracking Tools" key="3">
                   <div className="row clearfix m-0">
                    <div className="col-12">
                      <h3 className="main-heading">Tracking Tools</h3>
                    </div>
                    <div className="col-12">
                      <div className="row clearfix m-0">
                        <div className="col-12 tracking-tool-tab">
                        <ul>
                          <li><a onClick={() => this.showWasteProfile(true)} href="#">Waste Profiles</a></li>
                          <li><a onClick={() => this.showAttachment(true)} href="#">Files & Attachments</a></li>
                          <li><a onClick={() => this.showDispatchHistory(true)} href="#">Dispatch History</a></li>
                          <li><a onClick={() => this.showHotsheet(true)} href="#">Hotsheets</a></li>
                        </ul>
                      </div>
                      </div>
                    </div>
                  </div>
                </TabPane>
              </Tabs>
            </div>
            <ShowWasteProfile visible={this.state.showWasteProfile} onCancel={() => this.showWasteProfile(false)}/>
            <DispatchHistory visible={this.state.visibleDispatch} onCancel={() => this.showDispatchHistory(false)}/>
            <AccountHotsheet visible={this.state.visibleHotsheet} onCancel={() => this.showHotsheet(false)}/>
            <AddUpdateWorkOrder visible={this.state.showAddWorkOrder}
                                setModelVisible={() => this.showAddWorkOrderModel(false)}/>
            <Attachments visible={this.state.visibleAttachment} onCancel={() => this.showAttachment(false)}/>
          </div>
        </div>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/analytics/in_development/InDevelopment.jsx